import { render, staticRenderFns } from "./communicationDashboardCampaign.vue?vue&type=template&id=58bc4705&scoped=true"
import script from "./communicationDashboardCampaign.vue?vue&type=script&lang=js"
export * from "./communicationDashboardCampaign.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardCampaign.vue?vue&type=style&index=0&id=58bc4705&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bc4705",
  null
  
)

export default component.exports